var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1137_896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8335 10V0H10.3335V10H0.333496V17.5H10.3335V20H17.8335V17.5H20.3335V10H17.8335ZM11.3335 7.8H13.7335V6.8H11.3335V3.8H13.7335V2.8H11.3335V1H16.8335V10H11.3335V7.8ZM16.8335 19H11.3335V17.5H16.8335V19ZM19.3335 16.5H16.8335V13.8H15.8335V16.5H12.8335V13.8H11.8335V16.5H8.8335V13.8H7.8335V16.5H4.8335V13.8H3.8335V16.5H1.3335V11H19.3335V16.5Z",
    fill: "#565755"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1137_896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqftIcon);
export default __webpack_public_path__ + "static/media/sqft-icon.e94861043d617d2e293b5c4d5e49568d.svg";
export { ForwardRef as ReactComponent };